/* NDC · Rediseño 2026-09 · Fase 1 · vanilla JS (defer).
   Módulos: toast, quick add "+", toggle grid/lista, drawer de filtros, contador móvil del botón "Ver n vinos",
   texto plegado, eventos GA4 (dataLayer). Convive con jQuery/Flex sin usarlos; el hot-reload de filtros lo hace
   <list-hot-reload> de Flex, que emite 'list:hot-reload:updated' tras re-renderizar. */
(function () {
  'use strict';
  var I18N = window.NDC_I18N || {};
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var mqDesktop = window.matchMedia('(min-width: 799px)');
  var isDesktop = function () { return mqDesktop.matches; };
  var track = function (payload) { try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) {} };

  /* ---------- Toast ---------- */
  var toastEl, toastTimer;
  function toast(msg, opts) {
    opts = opts || {};
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ndc-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.classList.toggle('is-error', !!opts.error);
    toastEl.textContent = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if (opts.linkHref) {
      var a = document.createElement('a');
      a.href = opts.linkHref;
      a.textContent = opts.linkText || '';
      toastEl.appendChild(a);
    }
    clearTimeout(toastTimer);
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, opts.duration || 3000);
  }

  /* ---------- K6 · cifra de precio (pasada T1.5): "S/. 320.00" → <i>S/.</i>320 (owner, 26 sep: "S/." y sin .00). Idempotente ---------- */
  /* Precios que pinta el JS de Flex (variantes, mini-cart): sin .00, como el Liquid (owner, 26 sep) */
  (function wrapMoney() {
    var S = window.Shopify;
    if (!S || typeof S.formatMoney !== 'function') { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wrapMoney); return; }
    if (S.formatMoney.ndcNoZeros) return;
    var f = S.formatMoney;
    S.formatMoney = function () { var out = f.apply(this, arguments); return typeof out === 'string' ? out.replace(/([.,])00(?=\D*$)/, '') : out; };
    S.formatMoney.ndcNoZeros = true;
  })();

  window.ndcK6 = function (el) {
    if (!el || el.querySelector('i')) return;
    var m = (el.textContent || '').replace(/\s+/g, ' ').trim().match(/^(S\/\.?)\s*(.+)$/);
    if (!m) return;
    el.textContent = '';
    var i = document.createElement('i');
    i.textContent = 'S/.';
    el.appendChild(i);
    el.appendChild(document.createTextNode(m[2].replace(/[.,]00$/, '')));
    el.classList.add('k-precio');
  };

  /* ---------- Quick add "+" (form[data-ndc-quick-add]) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-ndc-quick-add]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    var btn = form.querySelector('[data-ndc-plus]');
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var fd = new FormData(form);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    }).then(function (res) {
      btn.classList.remove('is-loading');
      if (!res.ok) {
        toast((res.body && (res.body.description || res.body.message)) || I18N.error || 'Error', { error: true, duration: 4000 });
        return;
      }
      btn.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('ndc:cart-added', { detail: { quantity: Number(fd.get('quantity')) || 1 } }));
      setTimeout(function () { btn.classList.remove('is-added'); }, 1200);
      toast(I18N.added || 'Añadido al carrito', { linkHref: root + 'cart', linkText: I18N.view_cart || 'Ver carrito' });
      // Flex: refresca el mini carrito y el contador [data-bind="itemCount"]
      try {
        if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
          window.PXUTheme.jsAjaxCart.updateView();
        }
      } catch (err) {}
      var item = res.body || {};
      var card = form.closest('[data-ndc-card]');
      track({
        event: 'quick_add',
        item_id: item.sku || item.variant_id,
        item_name: item.product_title,
        price: (item.price || 0) / 100,
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PEN',
        context: card ? card.getAttribute('data-ndc-context') : 'collection'
      });
    }).catch(function () {
      btn.classList.remove('is-loading');
      toast(I18N.error || 'Error', { error: true });
    });
  }, true);

  /* ---------- Colección: toggle, drawer, contador móvil, GA4 ---------- */
  var coll = document.querySelector('[data-ndc-collection]');
  if (coll) {
    var KEY = 'ndc_feed_view';
    var lastOpener = null;

    function applyView(view, persist) {
      if (view !== 'list') view = 'grid';
      coll.setAttribute('data-ndc-view', view);
      coll.querySelectorAll('[data-ndc-view-btn]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-ndc-view-btn') === view));
      });
      if (!persist) return;
      try { localStorage.setItem(KEY, view); } catch (e) {}
      // atributo de carrito para que la siguiente carga server-side coincida (cart.attributes.ndc_feed_view)
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { ndc_feed_view: view } })
      }).catch(function () {});
      track({ event: 'list_grid_toggle', view: view });
    }
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved && saved !== coll.getAttribute('data-ndc-view')) applyView(saved, false);

    // chip activo visible en la fila con scroll
    var activeChip = coll.querySelector('.ndc-chip.is-active');
    if (activeChip && activeChip.scrollIntoView && !isDesktop()) {
      try { activeChip.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {}
    }

    /* Drawer */
    function drawer() { return coll.querySelector('[data-ndc-drawer]'); }
    function focusables(el) {
      return Array.prototype.slice.call(el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea, summary, [tabindex]:not([tabindex="-1"])'))
        .filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
    }
    function openDrawer(opener) {
      var d = drawer();
      if (!d || isDesktop()) return;
      lastOpener = opener || null;
      d.setAttribute('data-open', 'true');
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-modal', 'true');
      document.body.classList.add('ndc-drawer-open');
      coll.querySelectorAll('[data-ndc-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var title = d.querySelector('#ndc-filter-title');
      if (title) { try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); } }
    }
    function closeDrawer(restoreFocus) {
      var d = drawer();
      document.body.classList.remove('ndc-drawer-open');
      if (d) {
        d.setAttribute('data-open', 'false');
        d.removeAttribute('role');
        d.removeAttribute('aria-modal');
      }
      coll.querySelectorAll('[data-ndc-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (restoreFocus !== false) {
        var target = (lastOpener && document.contains(lastOpener)) ? lastOpener : coll.querySelector('[data-ndc-drawer-open]');
        if (target) { try { target.focus({ preventScroll: true }); } catch (e) {} }
      }
    }
    function drawerIsOpen() { var d = drawer(); return !!d && d.getAttribute('data-open') === 'true'; }

    coll.addEventListener('click', function (e) {
      var t = e.target;
      var b = t.closest('[data-ndc-view-btn]');
      if (b) { applyView(b.getAttribute('data-ndc-view-btn'), true); return; }
      var o = t.closest('[data-ndc-drawer-open]');
      if (o) { e.preventDefault(); openDrawer(o); return; }
      if (t.closest('[data-ndc-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
      var d = drawer();
      if (d && drawerIsOpen() && t === d) { closeDrawer(); return; } // clic en el fondo oscuro
      var fold = t.closest('[data-ndc-fold-toggle]');
      if (fold) {
        var box = fold.closest('[data-ndc-fold]');
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        fold.setAttribute('aria-expanded', String(open));
        fold.textContent = open ? fold.getAttribute('data-less') : fold.getAttribute('data-more');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!drawerIsOpen() || isDesktop()) return;
      if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
      if (e.key !== 'Tab') return;
      var panel = drawer().querySelector('[data-ndc-drawer-panel]');
      var list = focusables(panel);
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    /* Móvil: los cambios dentro del drawer NO recargan el grid (eso lo hace el botón "Ver n vinos");
       solo actualizamos el contador del botón pidiendo la sección con los params actuales. */
    var countTimer = null, countAbort = null;
    function updateApplyCount(form) {
      var hr = coll.querySelector('list-hot-reload');
      var sectionId = hr && hr.getAttribute('section-id');
      var btn = form.querySelector('[data-ndc-apply]');
      if (!sectionId || !btn) return;
      var params = new URLSearchParams(new FormData(form));
      params.set('sections', sectionId);
      var url = (hr.getAttribute('context-url') || form.getAttribute('action')) + '?' + params.toString();
      if (countAbort) countAbort.abort();
      countAbort = new AbortController();
      fetch(url, { signal: countAbort.signal }).then(function (r) { return r.json(); }).then(function (j) {
        var html = j[sectionId];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var feed = doc.querySelector('[data-ndc-results]');
        if (!feed) return;
        var n = feed.getAttribute('data-ndc-results');
        var tpl = btn.getAttribute('data-ndc-apply-template') || '%n';
        btn.textContent = tpl.replace('%n', n);
      }).catch(function () {});
    }
    function interceptMobileChange(e) {
      if (isDesktop()) return;
      /* Las facetas locales (Uva/Zona) no viajan al servidor: las gestiona applyLocalFacets. */
      if (e.target.matches && e.target.matches('[data-ndc-local-input]')) return;
      var form = e.target.closest && e.target.closest('[data-ndc-filter-form]');
      if (!form) return;
      e.stopPropagation(); // que list-hot-reload no re-renderice con el drawer abierto
      clearTimeout(countTimer);
      countTimer = setTimeout(function () { updateApplyCount(form); }, 400);
    }
    document.addEventListener('change', interceptMobileChange, true);
    document.addEventListener('list:price-range:slider-change', interceptMobileChange, true);

    /* Inputs de precio vacíos: sin name, para que no viajen como filter.v.price.gte= en la URL */
    function syncPriceNames() {
      coll.querySelectorAll('[data-ndc-price-range] input').forEach(function (inp) {
        if (!inp.hasAttribute('data-name')) inp.setAttribute('data-name', inp.getAttribute('name') || '');
        if (inp.value === '') inp.removeAttribute('name'); else inp.setAttribute('name', inp.getAttribute('data-name'));
      });
    }
    syncPriceNames();
    document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('[data-ndc-price-range]')) syncPriceNames(); }, true);

    /* ---------- Facetas locales de Uva y Zona ----------
       La tienda aún no tiene Search & Discovery, así que Shopify no ofrece facetas por metafield.
       Estas dos filtran en el navegador sobre las cards ya pintadas: leen data-ndc-cepa y data-ndc-zona
       del snippet ndc-product-card. Se combinan con los filtros de Shopify (precio), que siguen
       viajando por URL. Cuando se instale Search & Discovery, el snippet ndc-local-facets deja de
       pintarlas y este bloque no encuentra nada que hacer. */
    var localMemory = { cepa: [], zona: [] };
    function localInputs() { return Array.prototype.slice.call(coll.querySelectorAll('[data-ndc-local-input]')); }
    function restoreLocalSelection() {
      localInputs().forEach(function (i) {
        var kind = i.getAttribute('data-ndc-local-input');
        i.checked = localMemory[kind].indexOf(i.value) !== -1;
      });
    }
    function localSelection() {
      var sel = { cepa: [], zona: [] };
      localInputs().forEach(function (i) { if (i.checked) sel[i.getAttribute('data-ndc-local-input')].push(i.value); });
      return sel;
    }
    function cardMatches(card, sel) {
      if (sel.cepa.length) {
        var cs = (card.getAttribute('data-ndc-cepa') || '').split('|');
        if (!sel.cepa.some(function (v) { return cs.indexOf(v) !== -1; })) return false;
      }
      if (sel.zona.length) {
        var z = card.getAttribute('data-ndc-zona') || '';
        if (sel.zona.indexOf(z) === -1) return false;
      }
      return true;
    }
    function applyLocalFacets(silent) {
      var grid = coll.querySelector('[data-ndc-grid]');
      if (!grid || !localInputs().length) return;
      var sel = localSelection();
      localMemory = sel;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-ndc-card]'));
      var shown = 0;
      cards.forEach(function (card) {
        var ok = cardMatches(card, sel);
        card.hidden = !ok;
        if (ok) shown++;
      });
      var active = sel.cepa.length + sel.zona.length;
      coll.setAttribute('data-ndc-local-active', active ? 'true' : 'false');

      /* Contador de la barra y del botón "Ver n vinos" */
      var feed = coll.querySelector('[data-ndc-results]');
      var total = feed ? Number(feed.getAttribute('data-ndc-results')) : cards.length;
      var noun = total === 1 ? 'vino' : 'vinos';
      var countEl = coll.querySelector('[data-ndc-count]');
      if (countEl) {
        if (!countEl.hasAttribute('data-ndc-count-base')) countEl.setAttribute('data-ndc-count-base', countEl.textContent);
        countEl.textContent = active ? (shown + ' de ' + total + ' ' + noun) : countEl.getAttribute('data-ndc-count-base');
      }
      var applyBtn = coll.querySelector('[data-ndc-apply]');
      if (applyBtn && active) {
        var tpl = applyBtn.getAttribute('data-ndc-apply-template') || '%n';
        var txt = tpl.replace('%n', shown);
        if (shown === 1) txt = txt.replace('vinos', 'vino');
        applyBtn.textContent = txt;
      }

      /* Badge por faceta y estado vacío */
      coll.querySelectorAll('[data-ndc-local-facet]').forEach(function (fac) {
        var kind = fac.getAttribute('data-ndc-local-facet');
        var badge = fac.querySelector('[data-ndc-local-active]');
        if (!badge) return;
        var n = sel[kind].length;
        badge.textContent = n ? ' (' + n + ')' : '';
        badge.hidden = !n;
      });
      var empty = coll.querySelector('[data-ndc-local-empty]');
      if (empty) empty.hidden = !(active && shown === 0);

      renderLocalChips(sel);
      if (!silent && active) {
        track({ event: 'filter_apply', filters: sel.cepa.map(function (v) { return 'cepa=' + v; }).concat(sel.zona.map(function (v) { return 'zona=' + v; })), results: shown, collection: coll.getAttribute('data-ndc-collection-handle') });
      }
    }
    function renderLocalChips(sel) {
      var host = coll.querySelector('[data-ndc-local-chips]');
      if (!host) return;
      host.textContent = '';
      var all = sel.cepa.map(function (v) { return ['cepa', v]; }).concat(sel.zona.map(function (v) { return ['zona', v]; }));
      all.forEach(function (pair) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ndc-chip ndc-chip--filter';
        b.setAttribute('data-ndc-local-remove', pair[0]);
        b.value = pair[1];
        b.textContent = pair[1];
        b.setAttribute('aria-label', 'Quitar ' + pair[1]);
        li.appendChild(b);
        host.appendChild(li);
      });
      host.hidden = all.length === 0;
    }
    coll.addEventListener('change', function (e) {
      if (!e.target.matches || !e.target.matches('[data-ndc-local-input]')) return;
      e.stopPropagation(); // no dispares el hot-reload de Flex: aquí no hay nada que pedir al servidor
      applyLocalFacets(false);
    }, true);
    coll.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('[data-ndc-local-remove]');
      if (rm) {
        e.preventDefault();
        localInputs().forEach(function (i) {
          if (i.getAttribute('data-ndc-local-input') === rm.getAttribute('data-ndc-local-remove') && i.value === rm.value) i.checked = false;
        });
        applyLocalFacets(true);
        return;
      }
      if (e.target.closest && e.target.closest('[data-ndc-local-clear]')) {
        e.preventDefault();
        localInputs().forEach(function (i) { i.checked = false; });
        applyLocalFacets(true);
      }
    });
    applyLocalFacets(true);

    /* Tras cada recarga AJAX de Flex: re-aplicar vista, cerrar drawer (se re-renderiza cerrado), GA4 */
    document.addEventListener('list:hot-reload:updated', function () {
      applyView(coll.getAttribute('data-ndc-view'), false);
      syncPriceNames();
      restoreLocalSelection();
      applyLocalFacets(true);
      var wasOpen = document.body.classList.contains('ndc-drawer-open');
      closeDrawer(wasOpen);
      initFolds();
      if (window.location.search.indexOf('filter.') !== -1) {
        var feed = coll.querySelector('[data-ndc-results]');
        var filters = [];
        new URLSearchParams(window.location.search).forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '') filters.push(k + '=' + v); });
        track({ event: 'filter_apply', filters: filters, results: feed ? Number(feed.getAttribute('data-ndc-results')) : undefined, collection: coll.getAttribute('data-ndc-collection-handle') });
      }
    });

    mqDesktop.addEventListener ? mqDesktop.addEventListener('change', function () { if (isDesktop()) closeDrawer(false); })
                               : mqDesktop.addListener(function () { if (isDesktop()) closeDrawer(false); });
  }

  /* ---------- Texto plegado: solo mostrar "Leer más" si hay algo que plegar ---------- */
  function initFolds() {
    document.querySelectorAll('[data-ndc-fold]').forEach(function (box) {
      var body = box.querySelector('[data-ndc-fold-body]');
      if (!body) return;
      var needs = body.scrollHeight > body.clientHeight + 8;
      box.classList.toggle('has-toggle', needs || box.classList.contains('is-open'));
    });
  }
  initFolds();
  window.addEventListener('load', initFolds);
  document.addEventListener('click', function (e) {
    var fold = e.target.closest && e.target.closest('[data-ndc-fold-toggle]');
    if (!fold || fold.closest('[data-ndc-collection]')) return; // dentro de la colección ya lo maneja coll
    var box = fold.closest('[data-ndc-fold]');
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    fold.setAttribute('aria-expanded', String(open));
    fold.textContent = open ? fold.getAttribute('data-less') : fold.getAttribute('data-more');
  });

  /* ---------- K10 · seis botellas del Pack ×6 (luces T1.9) ----------
     Repinta todos los [data-ndc-seis] con la cuenta real del carrito, que da la sección ndc-pack6-count (misma regla que el
     carrito). Se pide al cargar, tras el quick add (ndc:cart-added) y cuando Flex rehace el mini-carrito. */
  function seisPaint(n) {
    document.querySelectorAll('[data-ndc-seis]').forEach(function (w) {
      var of = Number(w.getAttribute('data-of')) || 6;
      var pct = w.getAttribute('data-pct') || '20';
      var k = Math.min(n, of);
      var box = w.querySelector('.k-seis');
      if (box) {
        box.querySelectorAll('.k-b').forEach(function (b, i) { b.classList.toggle('o', i >= k); });
        box.classList.toggle('ok', n >= of);
        box.setAttribute('aria-label', k + ' de ' + of + ' botellas para el Pack ×' + of);
      }
      var t = w.querySelector('.k-seis-t');
      if (t) {
        var add = function (s, bold) { var el = bold ? document.createElement('b') : document.createTextNode(s); if (bold) el.textContent = s; t.appendChild(el); };
        t.textContent = '';
        t.classList.toggle('ok', n >= of);
        if (n >= of) { add('Pack completo · '); add('−' + pct + ' %', true); add(' aplicado'); }
        else { add('Llevas '); add(String(k), true); add(' de ' + of + ' · faltan '); add(String(of - k), true); }
      }
      var num = w.querySelector('[data-ndc-seis-n]');
      if (num) num.textContent = k + ' de ' + of;
      w.setAttribute('data-n', String(n));
    });
  }
  var seisTimer;
  function seisRefresh() {
    if (!document.querySelector('[data-ndc-seis]')) return;
    clearTimeout(seisTimer);
    seisTimer = setTimeout(function () {
      var th = window.Shopify && window.Shopify.theme;
      var url = root + '?section_id=ndc-pack6-count' + (th && th.role !== 'main' ? '&preview_theme_id=' + th.id : '');
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (h) { var m = h.match(/data-ndc-pack6-count="(\d+)"/); if (m) seisPaint(Number(m[1])); })
        .catch(function () {});
    }, 300);
  }
  window.ndcSeisRefresh = seisRefresh;
  document.addEventListener('ndc:cart-added', seisRefresh);
  /* arreglo I-094: el botón de compra de Flex, el "Añadir" de la barra fija y quitar una línea del mini-carrito no cambian
     los hijos del primer [data-ajax-cart-content] (el de escritorio; en móvil Flex rellena el segundo), así que el observador
     de abajo no los ve. Se repinta también cuando termina una petición jQuery de Flex al carrito. Mismo seisRefresh. */
  if (window.jQuery) jQuery(document).ajaxComplete(function (e, x, o) { if (o && /\/cart\/(add|change|update|clear)/.test(o.url || '')) seisRefresh(); });
  (function () {
    var c = document.querySelector('[data-ajax-cart-content]');
    if (c && 'MutationObserver' in window) new MutationObserver(seisRefresh).observe(c, { childList: true });
  })();
  seisRefresh();
  window.addEventListener('pageshow', function (e) { if (e.persisted) seisRefresh(); });

  /* ---------- S3 · celdas: aviso de error dentro de la celda ---------- */
  (function () {
    if (!document.querySelector('form .ndc-celdas')) return;
    var focused = false;
    var cellOf = function (el) { return el && el.closest ? el.closest('.ndc-celdas .ndc-celda') : null; };
    function clearCell(c) {
      c.classList.remove('is-error');
      var m = c.querySelector('.ndc-celda__err');
      if (m) m.parentNode.removeChild(m);
      var ctrls = c.querySelectorAll('[aria-invalid]');
      for (var i = 0; i < ctrls.length; i++) {
        ctrls[i].removeAttribute('aria-invalid');
        if (ctrls[i].getAttribute('data-ndc-err-id')) {
          ctrls[i].removeAttribute('aria-describedby');
          ctrls[i].removeAttribute('data-ndc-err-id');
        }
      }
    }
    document.addEventListener('invalid', function (e) {
      var el = e.target, c = cellOf(el);
      /* arreglo I-038 e I-234: un control obligatorio fuera de las celdas (radio o casilla sin marcar) que va detrás de una celda
         con error en la misma pasada no recibe el aviso del navegador, y así el navegador no le lleva el foco ni baja la página
         hasta él. Si va delante de la primera celda con error, o si no hay celdas con error, conserva su aviso nativo. */
      if (!c) { if (focused) e.preventDefault(); return; }
      e.preventDefault();
      var msg = (el.validity && el.validity.valueMissing)
        ? (el.getAttribute('data-ndc-err') || 'Campo obligatorio')
        : el.validationMessage;
      c.classList.add('is-error');
      el.setAttribute('aria-invalid', 'true');
      var m = c.querySelector('.ndc-celda__err');
      if (!m) {
        m = document.createElement('span');
        m.className = 'ndc-celda__err';
        m.id = (el.id || el.name.replace(/[^a-z0-9]/gi, '')) + '-err';
        c.appendChild(m);
      }
      m.textContent = msg;
      if (!el.getAttribute('aria-describedby')) {
        el.setAttribute('aria-describedby', m.id);
        el.setAttribute('data-ndc-err-id', m.id);
      }
      if (!focused) { focused = true; el.focus(); setTimeout(function () { focused = false; }, 0); }
    }, true);
    var onEdit = function (e) {
      var c = cellOf(e.target);
      if (c && c.classList.contains('is-error') && e.target.validity && e.target.validity.valid) clearCell(c);
    };
    document.addEventListener('input', onEdit, true);
    document.addEventListener('change', onEdit, true);
  })();

  /* ---------- Horario del winebar (snippets/ndc-horario.liquid · área T1.12) ----------
     Marca .is-hoy en las filas [data-dias] del día de hoy y escribe el estado en .ndc-horario-estado,
     con la hora de Lima. Sin JS o sin Intl: se ve el horario fijo y el estado queda oculto. */
  (function () {
    var els = document.querySelectorAll('[data-ndc-horario]');
    if (!els.length) return;
    var p = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Lima', weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    } catch (e) { return; }
    var hoy = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(p.weekday);
    if (hoy < 0) return;
    var ahora = (parseInt(p.hour, 10) % 24) + parseInt(p.minute, 10) / 60;
    var fecha = p.day + '/' + p.month;
    /* arreglo I-044/I-045: fecha dd/mm de Lima a i días de hoy (Lima no cambia de hora: sumar días en ms es seguro),
       y fechas sin servicio escritas como "1/1" o "25/12/2026" normalizadas a "01/01" y "25/12" */
    function dm(i) { var q = {}; new Intl.DateTimeFormat('en-US', { timeZone: 'America/Lima', day: '2-digit', month: '2-digit' }).formatToParts(new Date(Date.now() + i * 864e5)).forEach(function (x) { q[x.type] = x.value; }); return q.day + '/' + q.month; }
    function ddmm(s) { var m = s.split('/'); return m.length < 2 ? s : ('0' + parseInt(m[0], 10)).slice(-2) + '/' + ('0' + parseInt(m[1], 10)).slice(-2); }
    var dias = ['el lunes', 'el martes', 'el miércoles', 'el jueves', 'el viernes', 'el sábado', 'el domingo'];
    function hora(h) { h = h % 24; return (h === 0 ? 12 : h > 12 ? h - 12 : h) + (h < 12 ? ' am' : ' pm'); }
    function art(h) { h = h % 24; return (h === 1 || h === 13) ? 'la ' : 'las '; }
    function tramo(v) {
      if (!v || v.indexOf('-') < 0) return null;
      var a = parseInt(v.split('-')[0], 10), b = parseInt(v.split('-')[1], 10);
      if (isNaN(a) || isNaN(b)) return null;
      if (b <= a) b += 24;
      return [a, b];
    }
    Array.prototype.forEach.call(els, function (el) {
      var hs = (el.getAttribute('data-horas') || '').split('|');
      var lista = (el.getAttribute('data-cerrado') || '').split(',').map(ddmm);
      var cerradoHoy = lista.indexOf(fecha) > -1;
      /* arreglo I-042/I-144: tras medianoche sigue abierto el tramo de ayer (si ayer hubo servicio) y se marca esa fila;
         arreglo I-044: un día sin servicio no marca ninguna fila */
      var ay = lista.indexOf(dm(-1)) > -1 ? null : tramo(hs[(hoy + 6) % 7]);
      var tras = !!(ay && ay[1] > 24 && ahora < ay[1] - 24);
      var dia = tras ? (hoy + 6) % 7 : (cerradoHoy ? -1 : hoy);
      Array.prototype.forEach.call(el.querySelectorAll('[data-dias]'), function (r) {
        if (dia > -1 && r.getAttribute('data-dias').split(',').indexOf(String(dia)) > -1) r.classList.add('is-hoy');
      });
      if (!el.classList.contains('ndc-horario-estado')) return;
      var t = cerradoHoy ? null : tramo(hs[hoy]);
      var txt = '', abierto = false;
      if (tras) { abierto = true; txt = 'Abierto hasta ' + art(ay[1]) + hora(ay[1]); }
      else if (t && ahora >= t[0] && ahora < t[1]) { abierto = true; txt = 'Abierto hasta ' + art(t[1]) + hora(t[1]); }
      else if (t && ahora < t[0]) { txt = 'Cerrado · abre hoy a ' + art(t[0]) + hora(t[0]); }
      else {
        for (var i = 1; i <= 7; i++) {
          if (lista.indexOf(dm(i)) > -1) continue; /* arreglo I-044/I-069: no anuncia un día sin servicio */
          var n = tramo(hs[(hoy + i) % 7]);
          if (n) { txt = (cerradoHoy ? 'Cerrado hoy' : 'Cerrado') + ' · abre ' + (i === 1 ? 'mañana' : dias[(hoy + i) % 7]) + ' a ' + art(n[0]) + hora(n[0]); break; }
        }
      }
      if (!txt) return;
      el.textContent = txt;
      el.classList.add(abierto ? 'is-abierto' : 'is-cerrado');
      el.hidden = false;
    });
  })();

  /* M3 · menú móvil: la página puede venir de caché; si la fecha de la próxima cata ya pasó, se quita el dato */
  document.querySelectorAll('[data-ndc-ts]').forEach(function (el) {
    if (Number(el.getAttribute('data-ndc-ts')) * 1000 < Date.now()) el.remove();
  });

  /* ---------- Tablas del RTE como ficha bajo 600 px (pasada gráfica L3 · pasada T4.2) ----------
     Solo tablas dentro de .ndc-article (artículos y páginas ndc-page-main) con fila de cabecera:
     primera fila toda en <th>, o toda en <td> cuyo texto entero va dentro de <strong>/<b>.
     Sin cabecera, con una sola columna, con celdas combinadas, con imágenes o con tablas dentro: quedan como hoy.
     display:block quita la semántica de tabla en Safari/VoiceOver, por eso se ponen los roles ARIA. */
  function initFichaTablas() {
    document.querySelectorAll('.ndc-article table').forEach(function (t) {
      if (t.hasAttribute('data-ndc-ficha')) return;
      if (t.closest('.ndc-article-products, .ndc-offer')) return;
      if (t.querySelector('img, table')) return;
      var rows = t.rows;
      if (rows.length < 2) return;
      var n = rows[0].cells.length;
      if (n < 2) return;
      var i, j, c;
      for (i = 0; i < rows.length; i++) {
        if (rows[i].cells.length !== n) return;
        for (j = 0; j < n; j++) {
          c = rows[i].cells[j];
          if (c.colSpan > 1 || c.rowSpan > 1) return;
        }
      }
      var labels = [];
      for (j = 0; j < n; j++) {
        c = rows[0].cells[j];
        var txt = c.textContent.replace(/\s+/g, ' ').trim();
        if (c.tagName !== 'TH') {
          var s = c.querySelector('strong, b');
          if (!s || s.textContent.replace(/\s+/g, ' ').trim() !== txt) return;
        }
        labels.push(txt);
      }
      t.setAttribute('role', 'table');
      for (i = 0; i < t.children.length; i++) {
        var g = t.children[i].tagName;
        if (g === 'THEAD' || g === 'TBODY' || g === 'TFOOT') t.children[i].setAttribute('role', 'rowgroup');
      }
      rows[0].classList.add('ndc-ficha__cab');
      for (i = 0; i < rows.length; i++) {
        rows[i].setAttribute('role', 'row');
        for (j = 0; j < n; j++) {
          c = rows[i].cells[j];
          if (i === 0) c.setAttribute('role', 'columnheader');
          else if (j === 0) c.setAttribute('role', 'rowheader');
          else { c.setAttribute('role', 'cell'); if (labels[j]) c.setAttribute('data-label', labels[j]); }
        }
      }
      t.classList.add('ndc-tabla-ficha');
      t.setAttribute('data-ndc-ficha', '');
    });
  }
  initFichaTablas();
})();
